import { transformDateToLocalDateString } from "helpers";
import { FleetVehicleFireExtinguisherRow } from "services/api/fleet/vehicles/fireextinguishers/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const FLEET_VEHICLE_FIRE_EXTINGUISHER_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => [
    {
      title: "admin.fleet.vehicle.fireextinguisher.search.name",
      key: "fire_name",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div className="text-md font-medium text-slate-600">{row.name}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.fireextinguisher.search.serialnumber",
      key: "fire_serial",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div className="text-sm text-slate-500 truncate">{row.serialNumber}</div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.fireextinguisher.search.amount",
      key: "fire_amount",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div>
            <div className="text-sm text-slate-900 truncate">
              {row.price} €
            </div>
          </div>
        );
      },
    },
    {
      title: "admin.fleet.vehicle.expense.search.expirationdate",
      key: "fire_expiry",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return <div className="text-sm text-slate-900 truncate">{transformDateToLocalDateString(row.expirationDate)}</div>;
      },
    },
    {
      title: "admin.fleet.vehicle.fireextinguisher.search.weight",
      key: "fire_weight",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <div>
            <div className="text-sm text-slate-900 truncate">
              {row.weight} kg
            </div>
          </div>
        );
      },
    },
    {
      title: "",
      key: "fire_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetVehicleFireExtinguisherRow) => {
        return (
          <ButtonMenu endIcon="/media/icons/more-dots.svg" variant="text">
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              onClick={(e) => handleDeleteClick(e, row.id)}
            >
              Obriši
            </ButtonMenuItem>
          </ButtonMenu>
        );
      },
    },
  ];



